import type { PMPluginFactoryParams } from '@atlaskit/editor-common/types/plugin-factory';

import type { AiAutocompletePlugin } from './aiAutocompletePluginType';
import { createAiAutocompleteKeymapPlugin } from './pm-plugins/keymap-plugin/ai-autocomplete-keymap';
import { createAiAutocompletePlaceholderControllerPlugin } from './pm-plugins/placeholder-controller/placeholder-controller-plugin';
import { acceptSuggestionCommand, dismissSuggestionCommand } from './ui/components/commands';
import { createPlugin } from './ui/components/main';

export const aiAutocompletePlugin: AiAutocompletePlugin = ({ api }) => {
	return {
		name: 'aiAutocomplete',
		commands: {
			acceptSuggestion: (params) => acceptSuggestionCommand(params, api?.analytics?.actions),
			dismissSuggestion: () => dismissSuggestionCommand(api?.analytics?.actions),
		},
		pmPlugins() {
			return [
				{
					name: 'aiAutocompletePlugin',
					plugin: () => createPlugin({ api }),
				},
				{
					name: 'ai-autocomplete-keymap',
					plugin: (params: PMPluginFactoryParams) =>
						createAiAutocompleteKeymapPlugin({
							api,
							getIntl: params.getIntl,
						}),
				},
				{
					name: 'ai-autocomplete-placeholder-controller',
					plugin: () => createAiAutocompletePlaceholderControllerPlugin({ api }),
				},
			];
		},
	};
};
